import { Component, Injector } from "@angular/core";
import { FilterDataType, MatTableCrudComponent } from "../../../shared/components/mat-table-crud/mat-table-crud.component";
import { MatTableCrudService } from "../../../shared/components/mat-table-crud/mat-table-crud.service";
import { AuthorisationService } from "../../../shared/services/authorisation.service";
import { ConfigurationService } from "../../../shared/services/configuration.service";
import { ContactType } from "../../calendars/calendars.models";
import { AdministrationService } from '../administration.service';
import { ContactTypeEditComponent } from "./contact-type-edit.component";
import { MatPaginatorModule } from "@angular/material/paginator";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";


@Component({
    templateUrl: './contact-types.component.html',
    styleUrls: ['./contact-types.component.scss', '../../../shared/components/mat-table-crud/mat-table-crud.component.scss'],
    providers: [MatTableCrudService],
    standalone: true,
    imports: [MatCardModule, MatButtonModule, MatIconModule, MatTableModule, MatSortModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatPaginatorModule]
})
export class ContactTypesComponent extends MatTableCrudComponent<ContactType>
{
  public ContactTypeNameFilter: any;

  constructor(
    public authorisationService: AuthorisationService,
    protected injector: Injector,
    public configurationService: ConfigurationService,
    public administrationService: AdministrationService
  )
  {
    super(injector,
      ContactTypeEditComponent,
      ContactTypeEditComponent,
      ContactTypeEditComponent,
      "CreateContactType",
      "DeleteContactType",
      "GetContactTypes",
      "UpdateContactType",
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl);

    this.changedByField = "ChangedByUserId";

    this.displayedColumns = ['Id', 'ContactTypeName'];
    this.filteredValues = [{ Field: "ContactTypeName", Value: "", Path: "", DataType: FilterDataType.String }];

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.width = "24rem";

    this.CanAdd = false; //this.authorisationService.hasPermission(this.authorisationService.Permissions.AddContactTypes);
    this.CanEdit = this.authorisationService.hasPermission(this.authorisationService.Permissions.EditContactTypes);
    this.CanDelete = false; //this.authorisationService.hasPermission(this.authorisationService.Permissions.DeleteContactTypes);
  }

  ngOnInit(): void
  {
    super.ngOnInit();


  }

  addNew(event: any)
  {
    this.addedItem.SortOrder = 0;

    super.addNew(event);
  }

  deleteItem(event: any, contacttype: ContactType)
  {
    this.deleteConfirmationMessage = `Are you sure you want to delete this contact type (${contacttype.ContactTypeName})?`;
    this.deleteHeaderText = "Delete Contact Type?";

    super.deleteItem(event, contacttype);
  }



  ngOnDestroy()
  {
    super.ngOnDestroy();
  }











}

